export default "__VITE_ASSET__1c601f5d__"